module.exports = {
          srcSet: __webpack_public_path__ + "af8db7613c8cba626887353990389dfb-1110.png"+" 1110w",
          images:[ {path: __webpack_public_path__ + "af8db7613c8cba626887353990389dfb-1110.png",width: 1110,height: 298}],
          src: __webpack_public_path__ + "af8db7613c8cba626887353990389dfb-1110.png",
          toString:function(){return __webpack_public_path__ + "af8db7613c8cba626887353990389dfb-1110.png"},
          
          width: 1110,
          height: 298
        }